import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './styles.scss';

const Button = ({
  onClick, children, disabled, isLink, pathTo, className, inline
}) =>
  isLink ? (
    <Link
      to={pathTo}
      className={`button -isLink ${disabled ? '-disabled' : ''} ${inline ? '-inline' : ''}`}
    >
      {children}
    </Link>
  ) : (
    <button onClick={onClick} className={`button ${className} ${inline ? '-inline' : ''}`} disabled={disabled}>
      {children}
    </button>
  );

Button.defaultProps = {
  onClick: () => {},
  disabled: false,
  isLink: false,
  pathTo: '/',
  className: '',
  inline: false
};

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isLink: PropTypes.bool,
  pathTo: PropTypes.string,
  className: PropTypes.string,
  inline: PropTypes.bool
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js